import {createSelector} from 'reselect';

const selectDeviceProfiles = (state) => state.deviceProfiles;

export const makeSelectDeviceProfilesList = () =>
    createSelector(
        (state) => state.deviceProfiles.profilesList,
        (profilesList) => profilesList || []
    );

export const makeSelectCurrentProfile = () =>
    createSelector(selectDeviceProfiles, (profilesState) => profilesState?.currentProfile || null);
